<template>
  <div class="slide narrow" id="meet-your-mp" v-show="isVisibleSlide('meet-your-mp')">
    <div class="slide_inner">
      <div class="left"></div>
      <div class="container">
        <h1>meet your mp</h1>
        <p>Thanks for your interest in speaking to your MP in person about assisted dying. Just leave your details here, and we’ll be in touch soon to discuss setting up a meeting with your MP.</p>
        <p>We'll also give you guidance on what to say, and may be able to connect you with other people in your area so you can go to the meeting together.</p>
        <form class="action-form" @submit.prevent="submitForm">
          <div class="input-group">
            <input
              type="text"
              name="firstname"
              id="firstname"
              v-model="form.firstname"
              v-validate="'required|min:1'"
              hidden
            >
            <p
              v-if="errors.has('firstname')"
              class="validation-error"
              role="alert"
            >First name is required</p>
          </div>
          <div class="input-group">
            <input
              type="text"
              name="email"
              id="email"
              v-model="form.email"
              v-validate="'required|min:1'"
              hidden
            >
            <p v-if="errors.has('email')" class="validation-error" role="alert">Email is required</p>
          </div>
          <div class="input-group">
            <label for="phone">Phone Number</label>
            <input
              type="text"
              name="phone"
              id="phone"
              v-model="form.phone"
              v-validate="'required|min:1'"
            >
            <p
              v-if="errors.has('phone')"
              class="validation-error"
              role="alert"
            >Phone number is required</p>
          </div>
          <div class="input-group">
            <button type="submit" class="btn-submit">SIGN UP NOW</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import { mapState } from "vuex";

export default {
  name: "MeetYourMP",
  props: ["gotoSlide", "isVisibleSlide", "analytics"],
  data() {
    return {
      form: {
        firstname: null,
        email: null,
        phone: null
      }
    };
  },
  computed: mapState(["user"]),
  watch: {
    user(newValue) {
      this.form.firstname = newValue.firstname;
      this.form.email = newValue.email;
    }
  },
  methods: {
    dumpCookies(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() - 100 * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = "JSESSIONID= ;" + expires + ";path=/page";
      document.cookie =
        "en_sessionId= ;" +
        expires +
        ";path=/page;domain=.dignityindying.org.uk;";
    },
    submitForm() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.dumpCookies();
          const data = {
            hidden: "",
            "supporter.firstName": this.$store.state.user.firstname,
            "supporter.emailAddress": this.$store.state.user.email,
            "supporter.phoneNumber": this.form.phone,
            "supporter.questions.402492": this.$store.state.mp.priority, //priority
            "supporter.questions.408376": this.$store.state.mp.constituency, //const
            "supporter.questions.408377": this.$store.state.mp.name //name
          };

          const options = {
            method: "POST",
            headers: { "content-type": "application/x-www-form-urlencoded" },
            data: qs.stringify(data),
            withCredentials: false,
            url: "https://action.dignityindying.org.uk/page/40623/petition/2"
          };

          axios(options)
            .then(response => {
              console.log(response);
              this.$store.commit("updateUser", {
                ...this.$store.state.user,
                phone: this.form.phone
              });
              this.$store.commit("updateJourney", {
                journey: "leave_story",
                result: true
              });
              this.analytics("meet_your_mp", "submitted");
              this.gotoSlide("will-share");
            })
            .catch(error => {
              console.log(error);

              // just for testing offline
              // this.$store.commit("updateMP", this.mp);
              // this.$store.commit("updateUser", {
              //   ...this.$store.state.user,
              //   phone: this.form.phone
              // });
              // this.$store.commit("updateJourney", {
              //   journey: "leave_story",
              //   result: true
              // });
              // this.analytics("meet_your_mp", "submitted");
              // this.gotoSlide("will-share");
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.slide {
  background-image: url("https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/did-bg-ty2.jpg?v=1553529970000") !important;
}
</style>